import React from 'react';
import {
  Gutter,
  IconButton,
  Layout,
  Reveal,
  useScrollRegion,
  useScrollTo,
} from '@axiom/ui';

/**
 * ChatScrollDown - I am the way back to the newest turn, for a reader who has scrolled up through
 * the transcript. ONLY concerned with when to offer it and where it sits: the scrolling itself is
 * `useScrollTo`'s and the arriving and leaving is `Reveal`'s.
 */
export const ChatScrollDown = () => {
  const { isAwayFromBottom } = useScrollRegion();
  const { scrollTo } = useScrollTo({ to: 'bottom' });

  return (
    <Reveal animate isActive={isAwayFromBottom} name="CHAT_SCROLL_DOWN">
      <Gutter bottom="24px" gutterType="margin">
        <Layout position="center">
          <IconButton
            floating
            icon="move-down"
            name="CHAT_SCROLL_DOWN_BUTTON"
            onClick={scrollTo}
            pattern="primary"
            size="large"
            variation="outline"
          />
        </Layout>
      </Gutter>
    </Reveal>
  );
};
